module.exports = __webpack_public_path__ + "static/media/36b2c5d9-5814-4505-ba7a-f94849f9d8d9.4b39ad41.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274163/36b2c5d9-5814-4505-ba7a-f94849f9d8d9.woff2
// module id = 1671
// module chunks = 2